import { render, staticRenderFns } from "./preview-dust-db-record-dialog.component.vue?vue&type=template&id=03f3bce6"
import script from "./preview-dust-db-record-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./preview-dust-db-record-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03f3bce6')) {
      api.createRecord('03f3bce6', component.options)
    } else {
      api.reload('03f3bce6', component.options)
    }
    module.hot.accept("./preview-dust-db-record-dialog.component.vue?vue&type=template&id=03f3bce6", function () {
      api.rerender('03f3bce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin-panel/dust-db/preview-dust-db-record-dialog/preview-dust-db-record-dialog.component.vue"
export default component.exports